import React, { createContext, useState, useContext } from 'react';

type InputDeviceContextType = [MediaDeviceInfo | undefined, (device: MediaDeviceInfo) => void];

const InputDeviceContext = createContext<InputDeviceContextType | undefined>(undefined);

export const InputDeviceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedDevice, setSelectedDevice] = useState<MediaDeviceInfo | undefined>(undefined);

    return (
        <InputDeviceContext.Provider value={[selectedDevice, setSelectedDevice]}>
            {children}
        </InputDeviceContext.Provider>
    );
};

export const useInputDevice = () => {
    const context = useContext(InputDeviceContext);

    if (!context) {
        throw new Error('useInputDevice must be used within an InputDeviceProvider');
    }

    return context;
};
